<template>
    <v-row justify="center" class="appcontainer">
        <v-col cols="12" sm="8" v-if="checks.checkCount " class="pt-2 pb-2">
            <v-data-table
                :items="checksList"
                :item-key="_id"
                :headers= "headers"
            >
            </v-data-table>
        </v-col>
        <v-col cols="12" sm="8" v-else-if="checks.checksList ">
            Not available
        </v-col>
        <v-col cols="12" sm="8" v-else>
            <div class="text-center" style="margin-top:64px;">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </v-col>
    </v-row>
</template>
<script>

import { mapState } from 'vuex';

export default {
    name: 'Checks',
    data: () => {
        return {
            headers: [
                {
                    text: 'Type',
                    align: 'left',
                    sortable: true,
                    value: 'type'
                },
                {
                    text: 'Label',
                    align: 'left',
                    sortable: true,
                    value: 'label'
                },
                {
                    text: 'Interval',
                    align: 'left',
                    sortable: true,
                    value: 'interval'
                },
                {
                    text: 'Status',
                    align: 'left',
                    sortable: true,
                    value: 'state'
                }
            ]
        }
    },
    computed: {
        ...mapState(["currentUser", "checks", "now"]),
        checksList: function () {
            let list = Object.values(this.checks.checksList);
            let listlength = list.length;
            let i = listlength;
            while(i--){
                list[i].label = list[i].label || (list[i].parameters && list[i].parameters.target) || ""
            }
            return list;
        }
    },
    methods: {
        startPolling: function () {
            this.$store
                .dispatch("checks/getChecksList")
                .then( (results) => {
                    console.log('checks polling', results)
                })
        }
    },
    created () {
        this.startPolling();
    },
    beforeDestroy: function () {
        this.stopPolling()
    }
};
</script>
